import { Stack } from "@mui/material"
import { Button, Chip, Divider, Header, Icon, Typography } from "cakemail-ui-components-v2"
import { useTranslation } from "react-i18next"
import { TLandingCollaborations, TLandingFooter } from "./types"
import "./styles.scss"

export function LandingFooter({ support, title, desc, subDesc, ctaTitle, ctaTxt, cta }: TLandingFooter) {
    const { t, i18n } = useTranslation()
    return <Stack className="landingFooter" alignItems="center">
        <Stack alignItems="flex-start" gap={8}>
            <Stack direction={{ mobile: "column", xs: 'row' }} gap={8} justifyContent="space-between" width="100%" >
                <Header
                    support={support}
                    heading={title}
                    headingVariant="headlineL"
                    desc={desc}
                />
                <Stack gap={4} alignItems="center">
                    <Typography variant="headlineS">{ctaTitle}</Typography>
                    <Button onClick={cta} color="secondary" name="emailAPIFooterCTA" >{ctaTxt}</Button>
                </Stack>
            </Stack>
            <Divider color="wildSand" />
            <Stack >
                <Typography variant="body1L" color="silver.main">{subDesc}</Typography>
            </Stack>
        </Stack>
    </Stack>
}